<template>
  <div class="main-container">
    <!-- Header -->
    <HeaderHome />

    <!-- fomacion -->
    <FormacionesHeader />

    <!-- cursos -->
    <CursosHeader v-if="getCursosFechaMes.length > 0" />

    <!-- expertos -->
    <NuestrosExpertos />

    <!-- premium -->
    <UsuariosPremium />

    <!-- footer -->
    <SimpleFooterForum />
  </div>
</template>

<script>
import HeaderHome from "@/components/secciones/encabezado";
// Progrentis
import FormacionesHeader from "../components/secciones/formaciones";
import CursosHeader from "../components/secciones/cursos";
import NuestrosExpertos from "../components/secciones/nuestros-expertos";
import UsuariosPremium from "../components/secciones/usuarios-premium";
import SimpleFooterForum from "../components/secciones/simple-footer-forum";
import gql from "graphql-tag";

export default {
  name: "app",
  data() {
    return {
      getCursosFechaMes: [],
    };
  },
  created() {
    this.$apollo.queries.getCursosFechaMes.refetch();
  },
  apollo: {
    getCursosFechaMes: {
      query: gql`
        query {
          getCursosFechaMes {
            _id
            img
            nombre
            precio
            fecha_curso
            formato_curso
            tipo_curso
            categoria {
              _id
              nombre
            }
          }
        }
      `,
      pollInterval: 120000,
    },
  },
  components: {
    HeaderHome,
    // Progrentis
    FormacionesHeader,
    CursosHeader,
    NuestrosExpertos,
    UsuariosPremium,
    SimpleFooterForum,
  },
  metaInfo: {
    title: "Forum | Progrentis",
    htmlAttrs: {
      lang: "es",
      amp: true,
    },
  },
};
</script>
<style lang="scss" scoped>
// Fonts
@import url("https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
</style>